import React, { Component } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import store from "../../../store";
import HomePage from "./HomePage";
import Messages from "./Messages";
import ActivityFeedMobile from "./ActivityFeedMobile";
import HamburgerMenu from "./HamburgerMenu";
import handleMobileScroll from "../../utils/handleMobileScroll";
import Wrapper from "./styles/mobile-bottom-nav-styles";

class MobileBottomNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      burgerMenuActive: false,
      subNavActive: false,
      currentScrollPosition: null,
      scrollDirection: null,
    };
  }

  componentDidMount() {
    this.setState({ currentScrollPosition: window.scrollY });

    window.onscroll = () => {
      const { currentScrollPosition } = this.state;
      handleMobileScroll(currentScrollPosition);

      if (window.scrollY > currentScrollPosition) {
        this.setState({
          scrollDirection: "down",
        });
      }

      if (window.scrollY < currentScrollPosition) {
        this.setState({
          scrollDirection: "up",
        });
      }

      this.setState({
        currentScrollPosition: window.scrollY,
      });
    };
  }

  handleBurgerMenu = () => {
    const { burgerMenuActive } = this.state;

    this.setState({
      burgerMenuActive: !burgerMenuActive,
    });
  };

  handleSubNav = (type) => {
    const { subNavActive, burgerMenuActive } = this.state;

    if (type === "subnav") {
      this.setState({
        subNavActive: !subNavActive,
        burgerMenuActive: !burgerMenuActive,
        cameFromSubNav: true,
      });
    } else {
      this.setState({
        subNavActive: !subNavActive,
        burgerMenuActive: false,
        cameFromSubNav: false,
      });
    }
  };

  render() {
    const {
      unreadMessagesCount,
      mobileMenuLinks,
      homepageUrl,
      messagesUrl,
      isEmployer,
      candidatesSubNav,
    } = this.props;

    const { burgerMenuActive, subNavActive, scrollDirection, cameFromSubNav } =
      this.state;

    return (
      <Provider store={store}>
        <Wrapper
          id="mobile-bottom-nav"
          burgerMenuActive={burgerMenuActive}
          scrollDirection={scrollDirection}
        >
          <HomePage
            homepageUrl={homepageUrl}
            isEmployer={isEmployer}
            handleSubNav={this.handleSubNav}
          />
          <Messages
            unreadMessagesCount={unreadMessagesCount}
            messagesUrl={messagesUrl}
          />
          {!isEmployer && <ActivityFeedMobile />}
          <HamburgerMenu
            burgerMenuActive={burgerMenuActive}
            subNavActive={subNavActive}
            handleBurgerMenu={this.handleBurgerMenu}
            handleSubNav={this.handleSubNav}
            mobileMenuLinks={mobileMenuLinks}
            candidatesSubNav={candidatesSubNav}
            cameFromSubNav={cameFromSubNav}
            isEmployer={isEmployer}
          />
        </Wrapper>
      </Provider>
    );
  }
}

MobileBottomNav.propTypes = {
  unreadMessagesCount: PropTypes.number.isRequired,
  mobileMenuLinks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
      subNav: PropTypes.boolean,
      notificationDot: PropTypes.boolean,
    })
  ).isRequired,
  homepageUrl: PropTypes.string.isRequired,
  messagesUrl: PropTypes.string.isRequired,
  isEmployer: PropTypes.bool.isRequired,
  candidatesSubNav: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
    })
  ).isRequired,
};

export default MobileBottomNav;
